import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BaseListeComponent } from '@classes/extends';
import { TypeHeadElement } from '@classes/models';
import { FormValidator } from '@composants/validators';
import { Client, ControleperfService as ControlePerformancesService, Document, Fichier, ReferencesService, ServicesService, TypeFichier } from '@estel-numerique/galaclick-api';
import { DateHelper, FiltreHelper, FiltresService, TypeFiltre, PipesModule } from '@estel-numerique/galaclick-core';
import { Constantes } from '@services/util/constantes';
import { addMonths, addYears, isAfter, isEqual } from 'date-fns';
import { FileSaverService } from 'ngx-filesaver';
import { lastValueFrom } from 'rxjs';
import { DocumentCodeEnum } from '../../enums/codeDocument.enum';
import { DocumentDetailsComponent } from '../document-details/document-details.component';
import { DocumentEnvoisComponent, DocumentEnvoisComponentData } from '../document-envois/document-envois.component';
import { DialogGalaComponent } from '../../../composants/dialog-gala/dialog-gala.component';
import { SelectOuiNon, SelectFiltre } from '../../../composants/select/select.component';
import { DateGalaComponent } from '../../../composants/date-gala/date-gala.component';
import { MatButton } from '@angular/material/button';
import { NgClass } from '@angular/common';
import { CpIconSort } from '../../../composants/icons/icons.component';
import { ButtonGalaComponent } from '../../../composants/buttons/btn-gala/btn-gala.component';
import { MenuClientComponent } from '../../../composants/menu-context/menu-client/menu-client.component';
import { ButtonGalaSearchComponent } from '../../../composants/buttons/btn-gala-search/btn-gala-search.component';
import { PaginationV2Component } from '../../../composants/paginationV2/paginationV2.component';
import { DateFormatPipe } from '../../../../services/util/pipe';


/**
  * Page des plans de tournée
  */
@Component({
    providers: [],
    templateUrl: './document-liste.component.html',
    imports: [
        DialogGalaComponent, SelectOuiNon, SelectFiltre, FormsModule, ReactiveFormsModule, DateGalaComponent, MatButton, NgClass, CpIconSort, ButtonGalaComponent, MenuClientComponent,
        ButtonGalaSearchComponent, PaginationV2Component, PipesModule, DateFormatPipe
    ]
})
export class DocumentListeComponent extends BaseListeComponent implements OnInit {

    private filtresService = inject(FiltresService);
    private wsService = inject(ServicesService);
    private wsControlePerformances = inject(ControlePerformancesService);
    private wsReferenceService = inject(ReferencesService);
    private fileService = inject(FileSaverService);
    private formBuilder = inject(FormBuilder);
    private dialog = inject(MatDialog);
    private dialogRef = inject<MatDialogRef<DocumentListeComponent>>(MatDialogRef);

    public codeModule: string = Constantes.CodeOption.CDOCELEVEURS; // Code module/option testé pour vérifier l'accès à cette fonction (si null = OK)
    public titre: string;

    // Filtre
    protected listeServices: TypeFiltre<string>[] = [];
    protected listeDocs: TypeFiltre<string>[] = [];
    protected listeDocsSave: TypeFiltre<string>[] = [];
    protected listeClients: TypeFiltre<number>[] = null;
    protected isServicePesee = true;
    protected isServiceAutre = true;
    protected isDocumentSdc = true;
    protected isDocumentLst = true;

    protected codeSuiviDesControles = DocumentCodeEnum.SUIVIDESCONTROLES;
    protected codeLaitSansTaux = DocumentCodeEnum.LAITSANSTAUX;

    protected lgTrad: Record<string, string>;
    public headElements: TypeHeadElement[] = [];

    protected hasSearched = false;
    protected formDates = this.formBuilder.group({
        DDEBUT: ['', [Validators.required, FormValidator.validDate]],
        DFIN: ['', [Validators.required, FormValidator.validDate]],
    });
    public pfClient: number;
    get listeElementsAff() {
        return this.getListeAffichee<Document>();
    }
    constructor() {
        super();
        this.dialogRef.updateSize('1020px');
        this.titre = this.translate.instant('APPRECHERCHEDOCS.TITRE');
        this.lgTrad = {
            RET: this.translate.instant('RET'),
            RECHERCHER: this.translate.instant('SEARCH'),
            DEBUT: this.translate.instant("DEBUT"),
            PRECEDENT: this.translate.instant("PRECEDENT"),
            SUIVANT: this.translate.instant("SUIVANT"),
            FIN: this.translate.instant("FIN"),
            BEGINNINGDATE: this.translate.instant('BEGINNINGDATE'),
            ENDDATE: this.translate.instant('ENDDATE'),
            LISTEDOCS: this.translate.instant('APPRECHERCHEDOCS.COLTAB.LISTEDOCS'),
            PORTEFEUILLE: this.translate.instant('APPRECHERCHEDOCS.PORTEFEUILLE'),
        };
        this.headElements = [
            { libelle: this.translate.instant("APPRECHERCHEDOCS.COLTAB.CLIENT"), tri: '', sortable: false },
            { libelle: this.translate.instant("NOM"), tri: '', sortable: false },
            { libelle: this.translate.instant("SERV"), tri: '', sortable: false },
            { libelle: this.translate.instant("TYPE"), tri: '', sortable: false },
            { libelle: this.translate.instant("DATE"), tri: '', sortable: false }
        ];
    }

    ngOnInit() {
        super.ngOnInit();
        this.showModal().catch(e => this.util.fErreur(e));
    }

    public async showModal() {
        this.util.showLoader();
        try {
            // CHARGEMENT DES FILTRES
            await Promise.all([
                this.filtresService.getFiltreRFServiceDocs(),
                this.wsReferenceService.getRefTypeDoc().toPromise()
            ]).then((results) => {
                this.listeServices = results[0];
                this.listeDocsSave = [];
                const rfTypeDocs = results[1];
                rfTypeDocs.forEach(element => {
                    const typeFiltre = new TypeFiltre(element.CODE, element.LIB, false);

                    this.listeDocsSave.push(typeFiltre);
                });
                this.listeDocs = Object.assign([], this.listeDocsSave);
            }).catch((error) => { throw error; });


            const datedeb = new Date();
            datedeb.setMonth(datedeb.getMonth() - 3);
            const datefin = new Date();
            this.formDates.patchValue({
                DDEBUT: DateHelper.fConvDateTypescript(datedeb),
                DFIN: DateHelper.fConvDateTypescript(datefin)
            });

            this.pfClient = this.getUserSession().PORTEFEUILLE;

            await this.initListElement(this.pfClient);

        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }

    public async initListElement(pfClient: number) {
        this.util.showLoader();

        try {
            let clients: Client[] = [];
            // voir pour recup une liste plus light ?
            // les requetes vont chercher les services des clients qui ne sont pas réutilisé
            if (pfClient == 1) {
                clients = await this.wsCacheLow.getCLients(this.getUserSession().USRID).toPromise();
            } else {
                clients = await this.wsCacheLow.getCLients().toPromise();
            }
            // on applique quand même le filtre alors qu'il n'est pas sur la modale ?
            this.listeClients = this.filtresService.getFiltreClientsFromListe(clients, this.listeClients, true);
            this.listeClients = Object.assign([], this.listeClients);

        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }


    public async rechercherDocs() {
        const dDebut = this.formDates.value.DDEBUT;
        const dFin = this.formDates.value.DFIN;
        const selectionDocs = FiltreHelper.getSelectionAsString(this.listeDocs);
        const datesOk = this.checkDate(dDebut, dFin);
        const selectionClients = FiltreHelper.getSelectionAsNumber(this.listeClients);
        const periodOK = this.checkPeriode(dDebut, dFin, selectionDocs.length > 0, selectionClients.length > 0);
        if (this.formDates.invalid) {
            this.util.showToastError(this.translate.instant('APPRECHERCHEDOCS.DATEERROR') +
                ' - ' +
                this.translate.instant('APPRECHERCHEDOCS.PERIODESUP'));
            this.markAllFieldsAsTouched();
            return;
        } else if (datesOk) {
            this.util.showToastError(this.translate.instant('ERRORDATE'));
            return;
        }
        else if (!periodOK) {
            this.util.showToastError(this.translate.instant('APPRECHERCHEDOCS.PERIODESUP')
                .replace('%s', selectionDocs.length > 0 && selectionClients.length > 0 ? '12' : '4'));
            return;
        } else {
            if (dDebut <= dFin) {
                try {
                    this.util.showLoader();

                    const selectionServices = FiltreHelper.getSelectionAsString(this.listeServices);
                    this.hasSearched = true;

                    if (selectionServices.length > 0) {
                        this.isServicePesee = selectionServices.includes('PES');
                        this.isServiceAutre = selectionServices.includes('AU');
                    } else {
                        this.isServiceAutre = true;
                    }

                    if (selectionDocs.length > 0) {
                        this.isDocumentSdc = selectionDocs.includes(DocumentCodeEnum.SUIVIDESCONTROLES);
                    } else {
                        this.isDocumentSdc = true;
                    }

                    if (selectionDocs.length > 0) {
                        this.isDocumentLst = selectionDocs.includes(DocumentCodeEnum.LAITSANSTAUX);
                    }

                    this.fSetListeElements(await lastValueFrom(this.wsService.getAllDocuments(selectionClients, selectionServices, selectionDocs, dDebut, dFin, this.pfClient)));
                } catch (e) {
                    this.util.fErreur(e);
                } finally {
                    this.util.hideLoader();
                }
            }
        }

    }

    public changeService() {
        const selectionServices = FiltreHelper.getSelectionAsString(this.listeServices);
        this.listeDocs = this.listeDocsSave.filter(typeDoc => {
            if (selectionServices.length > 0) {
                let boOk = false;
                selectionServices.forEach(service => {
                    if (((typeDoc.value == "D" || typeDoc.value == "C") && service == "ANA") ||
                        ((typeDoc.value == "RI" || typeDoc.value == "LR" || typeDoc.value == "LP") && service == "PES") ||
                        (typeDoc.value == "MIR" && service == "MIR") ||
                        (typeDoc.value == "SDC" && service == "AU") ||
                        ((typeDoc.value == "QLT" || typeDoc.value == "TAR" || typeDoc.value == "REP" || typeDoc.value == "TRP") && service == "CSL") ||
                        (typeDoc.value == "BLS" && service == "BLN")) {
                        boOk = true;
                    }
                });
                return boOk;
            } else {
                return true;
            }
        });
        this.listeDocs = Object.assign([], this.listeDocs);
        this.resetListe();
    }

    public checkIfDocIsSuiviDesControlesAndResetList() {
        // si l'on souahite télécharger le document suivi des contrôles
        // alors on valorise par défaut la date de début au premier jour de l’année en cours « 01/01/AAAA » et la date de fin au « 31/12/AAAA »
        if (FiltreHelper.getSelectionAsString(this.listeDocs).includes(DocumentCodeEnum.SUIVIDESCONTROLES)) {
            this.formDates.patchValue({
                DDEBUT: DateHelper.fConvDateTypescript(new Date(new Date().getFullYear(), 0, 1)),
                DFIN: DateHelper.fConvDateTypescript(new Date(new Date().getFullYear(), 11, 31))
            });
        }
        this.resetListe();
    }

    public resetListe() {
        this.hasSearched = false;
    }

    public afficherEnvois(doc: Document) {
        this.dialog.open(DocumentDetailsComponent, { data: doc });
    }

    public openTelechargement(doc: Document) {
        this.dialog.open(DocumentEnvoisComponent, {
            data: {
                doc: doc,
                envoi: false
            } as DocumentEnvoisComponentData
        });
    }

    public openEnvoi(doc: Document) {
        this.dialog.open(DocumentEnvoisComponent, {
            data: {
                doc: doc,
                envoi: true
            } as DocumentEnvoisComponentData
        });
    }

    public async changePortefeuille(event: number) {
        this.pfClient = event;
        await this.initListElement(event);

    }

    public hideModal() {
        this.hasSearched = false;
        this.dialogRef.close();
    }

    public checkCreer() {
        return false;
    }

    public async telechargerSuivi(type: string) {
        const dDebut: string = this.formDates.value.DDEBUT;
        const dFin: string = this.formDates.value.DFIN === '' ? null : this.formDates.value.DFIN;
        const selectionClients: number[] = FiltreHelper.getSelectionAsNumber(this.listeClients);
        if (!dDebut || !dFin) {
            this.util.showToastError(this.translate.instant('MISSDATE'));
        } else {
            if (dDebut <= dFin) {
                await this.downloadSuivi(selectionClients, dDebut, dFin, type);
            } else {
                this.util.showToastError(this.translate.instant('ERRORDATE'));
            }
        }
    }

    private async downloadSuivi(clients: number[], dDebut: string, dFin: string, type: string) {
        try {
            this.util.showLoader();
            let res: Fichier;
            if (type === DocumentCodeEnum.SUIVIDESCONTROLES) {
                res = await lastValueFrom(this.wsControlePerformances.getSuivisDesControles(clients, dDebut, dFin, this.pfClient, TypeFichier.Excel));
            } else if (type === DocumentCodeEnum.LAITSANSTAUX) {
                res = await lastValueFrom(this.wsControlePerformances.getSuivisLaitSansTaux(clients, dDebut, dFin, this.pfClient, TypeFichier.Excel));
            }
            const fileName = res.nom;
            this.fileService.save(this.util.convertBase64toBlobExcel(res.contenu), fileName);
        } catch (e) {
            this.util.fErreur(e);
        }
        this.util.hideLoader();
    }

    private checkDate(dDebut: string, dFin: string): boolean {
        const dateDebut = new Date(dDebut);
        dateDebut.setHours(0, 0, 0, 0);

        const dateFin = new Date(dFin);
        dateFin.setHours(0, 0, 0, 0);

        return isAfter(dateDebut, dateFin) || isEqual(dateDebut, dateFin);
    }

    private checkPeriode(dDebut: string, dFin: string, docsSelected: boolean, cheptelSelected: boolean): boolean {
        const dateDebut = new Date(dDebut);
        dateDebut.setHours(0, 0, 0, 0);

        const dateFin = new Date(dFin);
        dateFin.setHours(0, 0, 0, 0);

        const dateFinMax = docsSelected || cheptelSelected ? addYears(dateDebut, 1) : addMonths(dateDebut, 4);

        return isAfter(dateFinMax, dateFin) || isEqual(dateFinMax, dateFin);
    }

    private markAllFieldsAsTouched(): void {
        Object.keys(this.formDates.controls).forEach(field => {
            const control = this.formDates.get(field);
            control?.markAsTouched({ onlySelf: true });
        });
    }
}
